module.exports = __webpack_public_path__ + "img/icon_scycd.0d570319.png";